import React from 'react';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';

import App from './App';

window.$ = window.jQuery = jQuery;

if (import.meta.env.PROD) {
  console.log = function () {};
  console.warn = function () {};
}

if (Window.AppConfig.bookmartIcon) {
  const bookmark = document.getElementById('link_bookmark');
  if (bookmark) {
    bookmark.href = '/images/' + Window.AppConfig.bookmartIcon;
  }
}

if (Window.AppConfig.shortcutIcon) {
  const shortcut = document.getElementById('link_shortcut');
  if (shortcut) {
    shortcut.href = '/images/' + Window.AppConfig.shortcutIcon;
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
